(function () {
  'use strict';

  function buildCustomSelect(nativeSelect) {
    if (nativeSelect.dataset.mlSortBuilt) return;
    nativeSelect.dataset.mlSortBuilt = 'true';

    var wrapper = document.createElement('div');
    wrapper.className = 'ml-sort';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'ml-sort__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var label = document.createElement('span');
    label.className = 'ml-sort__label';
    label.textContent = nativeSelect.options[nativeSelect.selectedIndex]
      ? nativeSelect.options[nativeSelect.selectedIndex].text
      : '';

    var caret = document.createElement('span');
    caret.className = 'ml-sort__caret';
    caret.innerHTML =
      '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true">' +
      '<path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    trigger.appendChild(label);
    trigger.appendChild(caret);

    var panel = document.createElement('ul');
    panel.className = 'ml-sort__panel';
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', 'Sort options');

    Array.from(nativeSelect.options).forEach(function (option) {
      var item = document.createElement('li');
      item.className =
        'ml-sort__option' + (option.selected ? ' ml-sort__option--selected' : '');
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', option.selected ? 'true' : 'false');
      item.dataset.value = option.value;
      item.textContent = option.text;

      item.addEventListener('click', function (e) {
        e.stopPropagation();
        nativeSelect.value = option.value;
        label.textContent = option.text;
        panel.querySelectorAll('.ml-sort__option').forEach(function (el) {
          el.classList.remove('ml-sort__option--selected');
          el.setAttribute('aria-selected', 'false');
        });
        item.classList.add('ml-sort__option--selected');
        item.setAttribute('aria-selected', 'true');
        close();
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        nativeSelect.dispatchEvent(new Event('input', { bubbles: true }));
      });

      panel.appendChild(item);
    });

    wrapper.appendChild(trigger);
    wrapper.appendChild(panel);

    nativeSelect.style.display = 'none';
    nativeSelect.parentNode.insertBefore(wrapper, nativeSelect);

    function open() {
      trigger.setAttribute('aria-expanded', 'true');
      wrapper.classList.add('ml-sort--open');
    }

    function close() {
      trigger.setAttribute('aria-expanded', 'false');
      wrapper.classList.remove('ml-sort--open');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      wrapper.classList.contains('ml-sort--open') ? close() : open();
    });

    document.addEventListener('click', close);

    panel.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  function init() {
    document
      .querySelectorAll(
        '.facets-vertical-sort .select__select, .facets__form .facet-filters__sort'
      )
      .forEach(buildCustomSelect);
  }

  /*
   * Dawn's renderAdditionalElements() replaces .sorting innerHTML
   * wholesale on every filter/sort update, which destroys our custom
   * dropdown. Watch every .sorting container for childList mutations
   * and re-init immediately after Dawn swaps the content.
   */
  function observeSortingContainers() {
    document.querySelectorAll('.sorting').forEach(function (container) {
      if (container.dataset.mlObserved) return;
      container.dataset.mlObserved = 'true';

      var observer = new MutationObserver(function () {
        init();
      });

      observer.observe(container, { childList: true, subtree: true });
    });
  }

  function setup() {
    init();
    observeSortingContainers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
